import { render, staticRenderFns } from "./PrintKeymap.vue?vue&type=template&id=dc81e0b2&"
import script from "./PrintKeymap.vue?vue&type=script&lang=js&"
export * from "./PrintKeymap.vue?vue&type=script&lang=js&"
import style0 from "./PrintKeymap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports